import { render } from "./theses_results.vue?vue&type=template&id=32c5f22a"
import script from "./theses_results.vue?vue&type=script&lang=js"
export * from "./theses_results.vue?vue&type=script&lang=js"

import exportComponent from "D:\\_FEproject\\aplikovanainformatika.sk\\zoneai\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__